
<template>
  <div v-if="timeData">
		<span v-if="timeData.perstate == 0" class="text-center left btnarea">关盘中</span>
      <span v-if=" timeData.perstate == 1" class="left bold mx-1">
        距离封盘:<span class="coudate">{{ time1 }}</span>
				&ensp;&ensp;非特停押:<span class="coudate">{{ time2 }}</span>
      </span>
    <span v-if=" timeData.perstate == 2" class="text-center left btnarea">等待开盘</span>
      <span v-if=" timeData.perstate == 3" class="left bold mx-1">
        距离封盘:<span class="coudate">{{ time1 }}</span>
				&ensp;&ensp;非特码停押:<span class="pgray bold">停押</span>
      </span>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import moment from "moment-timezone";
export default {
	props: {
    timeData: {
      type: Object,
      required: true, 
      default: {}
    }
  },
  data() {
    return {
			date1: null,
			date2: null,
			timeRrload: null
    };
	},
	computed: {
    time1: function () {
      if(this.date1 == null) return
      return this.timeText(this.date1)
		},
		time2: function () {
      if(this.date2 == null) return
      return this.timeText(this.date2)
    }
  },
  watch: {
    timeData: 'settingTime'
  },
  created () {
    this.settingTime(this.timeData)
  },
  beforeDestroy () {
    clearTimeout(this.timeRrload);
    this.date1 == null
    this.date2 == null
  },
  methods: {
    timeText (date) {
      const tiem = (val) => {
        return val < 10 ? `0${val}` : val
      }
      const h = tiem(date.get('hours'))
      const m = tiem(date.get('minutes'))
      const s = tiem(date.get('seconds'))
      return `${h}:${m}:${s}`
    },
    settingTime (val) {
      if(!Object.keys(val).length) return
      let strdate = moment(new Date(val.startdate)).valueOf()
      let stdate = moment(new Date(val.stdate)).valueOf();
      let cldate = moment(new Date(val.cldate)).valueOf();
      this.date1 = moment.tz(cldate - strdate, "Africa/Abidjan")
      this.date2 = moment.tz(stdate - strdate, "Africa/Abidjan")
      clearTimeout(this.timeRrload); 
			this.timeRrload = setInterval(() => {
				this.date1 = moment(this.date1.subtract(1, 'seconds'))
				this.date2 = moment(this.date2.subtract(1, 'seconds'))
			}, 1000);
    }
  }
};
</script>
